module.exports = __webpack_public_path__ + "static/media/pdf1.6c518be2.png";